/* loaded by smart-asset */
export default require("./assets/black-tote.i.svg")